import { CheckboxV2, Flex, Heading, Text } from '@pancakeswap/uikit'
import ConnectWalletButton from 'components/ConnectWalletButton'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ListformReceipt } from '../config'
import { CustomInput2 } from '../styles'

interface InfoProps {
    phoneNumber:string,
    setPhoneNumber:(newValue: string) => void,
    email:string,
    setEmail:(newValue: string) => void,
    setDeliveryMethod:(newValue: string) => void,
    deliveryMethod:string,
    isError:boolean,
    handleChangeInfo:(newValue: any) => void,
    account:string,
    priceRoute?:string,
    brandRoute?:string,
    productRoute?:string,
    router?:any,
    phoneNumberRoute?:string
}
const Info:React.FC<InfoProps> = ({
    phoneNumber,
    setPhoneNumber,
    email,
    setEmail,
    setDeliveryMethod,
    deliveryMethod,
    isError,
    handleChangeInfo,
    account,
    priceRoute,
    brandRoute,
    productRoute,
    router,
    phoneNumberRoute
}) => {
    const phoneno = /^\d{10}$/;
    // eslint-disable-next-line no-useless-escape
    const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    const handleChangePhoneNumber = (e) => {
        const { value } = e.target;
        // const phoneno = /^\d{10}$/;
        setPhoneNumber(value)
        // if(value.match(phoneno)){
        // }
    }

    const handleChangeEmail = (e) => {
        const { value } = e.target;
        // const phoneno = /^\d{10}$/;
        setEmail(value)
        // if(value.match(phoneno)){
        // }
    }
    useEffect(() => {
        if(phoneNumberRoute !== undefined && !phoneNumber){
            setPhoneNumber(phoneNumber)
        }
    },[phoneNumber, phoneNumberRoute, setPhoneNumber])

  return (
    <>
        <Flex width="100%" mt="1rem">
            <Flex width="100%" justifyContent="space-between" alignItems="flex-start" flexDirection="column" flexWrap="wrap" style={{gap:"1rem"}}>
                <Heading scale="lg">Thông tin người nhận quà</Heading>
                <Text fontSize={['12px', , '14px']}>Vui lòng điền đầy đủ thông tin số điện thoại người nhận và giá trị thẻ quà điện tử.</Text>
            </Flex>
        </Flex>
        <Flex width="100%" flexDirection="column">
            <Flex width="100%" alignItems="center">
                <Text fontWeight="bold">Chọn hình thức nhận</Text> <Text ml="4px" color="red">*</Text>
            </Flex>
            <Flex justifyContent={["space-between", ,"flex-start"]} flexDirection={["row", , "column"]} mt="0.5rem">
                {
                    ListformReceipt?.map((item) => {
                        return (
                            <Flex alignItems="center" mt="0.5rem">
                                <CheckboxV2
                                    scale="sm"
                                    name="confirmed"
                                    type="checkbox"
                                    disabled={item?.value === 'zalo'}
                                    checked={deliveryMethod === item?.value}
                                    onChange={() => setDeliveryMethod(item?.value)}
                                />
                                <Text ml={["6px", , ,"16px"]} fontSize={["12px", , "14px"]}>{item?.label}</Text>
                            </Flex>
                        )
                    })
                }
            </Flex>
        </Flex>
        <CsFlexInput>
            <div style={{ marginBottom: '20px', maxWidth: '100%', width: '100%' }}>                      
                <Flex width="100%" alignItems="center" justifyContent="space-between">
                    <Flex><Text fontWeight="bold">Số điện thoại</Text> <Text ml="4px" color="red">*</Text></Flex>
                    {
                        !account ?
                            <CsConnectWalletButton
                                routePath={router}
                            >
                                Kết nối ví
                            </CsConnectWalletButton>
                        : 
                        <>
                            <CsBtnChanges fontWeight="bold" color='change' 
                                onClick={handleChangeInfo}>
                                Chỉnh sửa
                            </CsBtnChanges>
                        </>
                    }
                </Flex>

                <Flex mt="0.5rem" justifyContent="flex-start">
                    <CustomInput2
                        type="text"
                        scale="lg"
                        value={phoneNumber}
                        placeholder="Nhập số điện thoại"
                        onChange={(e) => handleChangePhoneNumber(e)}
                        readOnly
                    />
                </Flex>
                {/* {
                    (!phoneNumber?.match(phoneno)) && <Text fontSize={["14px", , "16px"]} mt="0.5rem" color="red">Vui lòng nhập số điện thoại người nhận</Text>
                } */}
            </div>
            <div style={{ marginBottom: '20px', maxWidth: '100%', width: '100%' }}>                      
                <Flex width="100%" alignItems="center" justifyContent="space-between">
                    <Flex><Text fontWeight="bold">Email</Text> <Text ml="4px" color="red">*</Text></Flex>
                    {
                        !account ?
                            <CsConnectWalletButton
                                routePath={router}
                            >
                                Kết nối ví
                            </CsConnectWalletButton>
                        : 
                        <>
                            <CsBtnChanges fontWeight="bold" color='change' 
                                onClick={handleChangeInfo}>
                                Chỉnh sửa
                            </CsBtnChanges>
                        </>
                    }
                </Flex>
                <Flex mt="0.5rem" justifyContent="flex-start">
                    <CustomInput2
                        type="text"
                        scale="lg"
                        value={email}
                        placeholder="Nhập email"
                        readOnly
                        onChange={(e) => handleChangeEmail(e)}
                    />
                </Flex>
                {
                  (isError && !email.match(mailformat)) && <Text fontSize={["14px", , "16px"]} mt="0.5rem" color="red">Vui lòng nhập email người nhận</Text>
                }
            </div>
        </CsFlexInput>
    </>
  )
}
const CsConnectWalletButton = styled(ConnectWalletButton)`
    padding: 0;
    height:24px;
    font-weight: 700;
    width:fit-content;
    background: transparent;
    color: ${({theme}) => theme.colors.change}
`
const CsFlexInput = styled(Flex)`
     width: 100%;
     justify-content: space-between;
     align-items: flex-start;
     gap: 4rem;
     flex-direction: row;
     @media screen and (max-width: 768px){
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 0rem;
    }
`
const CsBtnChanges = styled(Text)`
    cursor: pointer;
    &:active{
        transform: translateY(1px);
    }
`

export default Info